<script setup lang="ts">
  import { Select, SelectOption } from 'ant-design-vue'
  import { watch, ref, computed } from 'vue'
  import { useWindowSize } from '@/composables/useWindowSize'
  import { AnalysisConfigOption } from '../models/AnalysisConfigOption'

  interface ISelectOrCreateAnalysisConfigConfigurationProps {
    options: Array<AnalysisConfigOption>
    modelValue: string
    placeHolder?: string
  }

  const props = defineProps<ISelectOrCreateAnalysisConfigConfigurationProps>()

  const emit = defineEmits<{
    'update:modelValue': [value: string]
  }>()

  const selectedValue = ref<string>(props.modelValue)

  watch(
    () => props.modelValue,
    (newVal) => {
      selectedValue.value = newVal
    },
    { immediate: true }
  )

  watch(selectedValue, () => {
    emit('update:modelValue', selectedValue.value)
  })

  const selectedValueAsArray = computed(() => {
    // If empty string, don't show anything in the dropdown
    return selectedValue.value?.trim() ? [selectedValue.value] : []
  })

  const handleChange = (val: Array<any>) => {
    // Only allow a single value
    const latest = (val || [])[val.length - 1]?.trim()

    // If nothing was selected or typed, emit an empty string
    selectedValue.value = latest ?? ''
  }

  const { controlSize } = useWindowSize()
</script>

<template>
  <Select
    mode="tags"
    v-model:value="selectedValueAsArray"
    :placeholder="props.placeHolder"
    @change="handleChange"
    :size="controlSize"
    class="w-full"
    showSearch
    allowClear
  >
    <SelectOption v-for="option in props.options" :key="option.value" :value="option.value">
      {{ option.label }}
    </SelectOption>
  </Select>
</template>
